import { IconButton, InputAdornment, SvgIcon, TextField } from '@mui/material';
import type { KeyboardEvent } from 'react';

export interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onSearch: (value: string) => void;
  onClear: () => void;
  placeholder?: string;
  width?: string | number | Record<string, string | number>;
}

export const SearchBar = ({
  value,
  onChange,
  onSearch,
  onClear,
  placeholder = 'Search...',
  width = '45%',
}: SearchBarProps) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onSearch(value);
    }
  };

  return (
    <TextField
      placeholder={placeholder}
      variant="outlined"
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={handleKeyDown}
      sx={{
        width,
        '& .MuiOutlinedInput-root': {
          borderRadius: '20px',
          backgroundColor: 'action.hover',
          '& fieldset': { border: 'none' },
          '&:hover fieldset': { border: 'none' },
          '&.Mui-focused fieldset': {
            border: '1px solid',
            borderColor: 'primary.main',
          },
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SvgIcon sx={{ fontSize: '1.25rem', color: 'text.secondary' }} viewBox="0 0 24 24">
              <path d="M15.755 14.2549H14.965L14.685 13.9849C15.665 12.8449 16.255 11.3649 16.255 9.75488C16.255 6.16488 13.345 3.25488 9.755 3.25488C6.165 3.25488 3.255 6.16488 3.255 9.75488C3.255 13.3449 6.165 16.2549 9.755 16.2549C11.365 16.2549 12.845 15.6649 13.985 14.6849L14.255 14.9649V15.7549L19.255 20.7449L20.745 19.2549L15.755 14.2549ZM9.755 14.2549C7.26501 14.2549 5.255 12.2449 5.255 9.75488C5.255 7.26488 7.26501 5.25488 9.755 5.25488C12.245 5.25488 14.255 7.26488 14.255 9.75488C14.255 12.2449 12.245 14.2549 9.755 14.2549Z" />
            </SvgIcon>
          </InputAdornment>
        ),
        endAdornment: value.trim().length > 0 && (
          <InputAdornment position="end" sx={{ mr: 0.5 }}>
            <IconButton
              size="small"
              onMouseDown={(e) => e.preventDefault()}
              onClick={onClear}
              aria-label="Clear search"
              sx={{ color: 'text.secondary' }}
            >
              <SvgIcon viewBox="0 0 24 24" sx={{ fontSize: '1.25rem' }}>
                <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" />
              </SvgIcon>
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
